import LinkButton from '@sats-group/ui-lib/react/link-button';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import BackgroundImage from '../background-image/background-image';
import ContentContainer from '../content-container/content-container';
import type { ConceptPageHeader as Props } from './concept-page-header.types';

const ConceptPageHeader: React.FC<Props> = ({
  actions,
  blurb,
  containment = ContentContainer.themes.wide,
  image,
  title,
}) => (
  <div className="concept-page-header">
    <div className="concept-page-header__inner">
      <ContentContainer theme={containment}>
        <div className="concept-page-header__content">
          <div className="concept-page-header__text">
            <Text
              elementName="h1"
              italic
              size={Text.sizes.headline1}
              theme={Text.themes.headline}
            >
              {title}
            </Text>
            <Text elementName="p" size={Text.sizes.large}>
              {blurb}
            </Text>
          </div>
          <div className="concept-page-header__actions">
            {actions.map((entry, index) => (
              <div key={entry.href}>
                <LinkButton
                  {...entry}
                  size={LinkButton.sizes.large}
                  variant={
                    index
                      ? LinkButton.variants.ctaSecondaryWhite
                      : LinkButton.variants.cta
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </ContentContainer>
      <div className="concept-page-header__flair">
        {image ? (
          <BackgroundImage
            {...image}
            focusArea={BackgroundImage.focusAreas.Faces}
          />
        ) : null}
      </div>
    </div>
  </div>
);

export default ConceptPageHeader;
